import React from "react";
import { Link } from "react-router-dom";
import { useAboutUs } from "../../../hooks/apis/main";
import parse from "html-react-parser";

function Section3_index() {

    const { data: aboutData, isLoading, error } = useAboutUs();

    if (isLoading) return <div className="active loading">
        <img src="/images/loading.svg" className="img-fluid" />
    </div>;
    if (error) return <p>Error</p>;

    return (
        <div id="section3">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-12">
                        <img src={process.env.PUBLIC_URL + '/images/about-right.png'} className="img-fluid" alt="" title="" />
                    </div>
                    <div className="col-lg-5 col-12">
                        <div className="about-us">
                            <h2>
                                دربــاره رستوران
                                <span>باغبان</span>
                            </h2>
                            <div className="desc">
                                {parse(aboutData.data.page_detail.description)}
                            </div>
                            <Link to="about-us">مشاهده جزییات</Link>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 d-lg-block d-none">
                        <div className="about-img">
                            <img src={process.env.PUBLIC_URL + '/images/about-left1.png'} className="img-fluid" alt="" title="" />
                            <img src={process.env.PUBLIC_URL + '/images/about-left2.png'} className="img-fluid about-img2" alt="" title="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Section3_index;